<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"EMPLOYEE.BANK.BANKDETAIL"|translate}}</h5>
      <div class="edit-icons" (click)="onCancel()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center" >
      <form action="" class="o-h" [formGroup]="addForm" (ngSubmit)="onSubmit()">
          <div class="row">
              <div class="col-md-6 mt-3 mt-3 mt-lg-4">
                  <label for="">{{"EMPLOYEE.BANK.ACCOUNTHOLDERNAME"|translate}}</label>
                  <div class="form-input">
                      <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NAME' | translate}}" formControlName="ac_hn">                  
                  </div>
                  <mat-error *ngIf="isControlHasError('ac_hn','required')">  {{"COMMON.THR"|translate}}</mat-error>
              </div>
              <div class="col-md-6 mt-3 mt-lg-4">
                <label for="">{{"EMPLOYEE.BANK.ACCOUNTNUMBER"|translate}}</label>
                <div class="form-input">
                    <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.BANK.ACCOUNTNUMBER'|translate}}" 
                    formControlName="ac_n">                  
                </div>
                <mat-error *ngIf="isControlHasError('ac_n','required')">  {{"COMMON.THR"|translate}}</mat-error>
              </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-3 mt-3 mt-lg-4">
                <label for="">{{"EMPLOYEE.BANK.BANKNAME"|translate}}</label>
                <div class="form-input">
                    <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NAME' | translate}}" formControlName="b_n">                  
                </div>
                <mat-error *ngIf="isControlHasError('b_n','required')">  {{"COMMON.THR"|translate}}</mat-error>
            </div>
            <div class="col-md-6 mt-3 mt-lg-4">
              <label for="">{{"EMPLOYEE.BANK.IBAM"|translate}}</label>
              <div class="form-input">
                  <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NUMBER' | translate}} " formControlName="ib_n">                  
              </div>
              <mat-error *ngIf="isControlHasError('ib_n','required')">  {{"COMMON.THR"|translate}}</mat-error>
            </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-3 mt-3 mt-lg-4">
              <label for="">{{"EMPLOYEE.BANK.PPSNUMBER"|translate}}</label>
              <div class="form-input">
                  <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NUMBER' | translate}}" formControlName="pps_n">                  
              </div>
              <mat-error *ngIf="isControlHasError('pps_n','required')">  {{"COMMON.THR"|translate}}</mat-error>
          </div>
          <div class="col-md-6 mt-3 mt-lg-4">
            <label for="">{{"EMPLOYEE.BANK.SORTCODE"|translate}}</label>
            <div class="form-input">
                <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.CODE' | translate}}" formControlName="s_c">                  
            </div>
            <mat-error *ngIf="isControlHasError('s_c','required')"> {{"COMMON.THR"|translate}}</mat-error>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-3 mt-3 mt-lg-4">
              <label for="">{{"EMPLOYEE.BANK.BANKADDRESS"|translate}}</label>
              <div class="form-input">
                  <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.ADDRESS' | translate}}" formControlName="b_add">                  
              </div>
              <mat-error *ngIf="isControlHasError('b_add','required')">  {{"COMMON.THR"|translate}}</mat-error>
          </div>
       
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-md-6 m-auto">
        <button mat-raised-button   color="primary"  class="auth-form-btn mt-3 mt-lg-4"  type="submit" (click)="onSubmit()">{{ "BUTTON.SAVE" | translate }}</button>
      </div>
    </div>
  </div>
  <app-loading-spinner></app-loading-spinner>